<template>
  <div class="set-meal" ref="setMeal">
    <div class="title">套餐详情</div>
    <div class="sku-list">
      <template v-for="(skuItem, index) in data">
        <div
          :class="`sku-name ${index == current && 'active'}`"
          v-if="skuItem.skuName"
          :key="index"
          @click="swipeTo(index)"
        >
          {{ skuItem.skuName }}
        </div>
      </template>
    </div>
    <van-swipe
      class="container"
      scroll-x="true"
      enable-flex="true"
      @change="onSwiperChange"
      :loop="false"
      :show-indicators="false"
      :style="`height:${swiperHeight[current]}px`"
      ref="swiper"
    >
      <van-swipe-item v-for="(skuItem, index) in data" :key="index">
        <div :class="`sku-item sku-item-${index}`">
          <template>
            <template v-for="setMealItem in skuItem.detailPartList">
              <div class="setmeal-item" @click="getSkuSwiperItemHeight">
                <div class="setmeal-name">
                  {{ setMealItem.name }}
                </div>
                <div class="item" v-for="item in setMealItem.itemList" :key="item.id">
                  <div class="name">
                    {{ item.name }}
                    <!-- <FlodText :text="item.name" /> -->
                  </div>
                  <div class="num">
                    <template v-if="skuItem.symbolDisplayStatus">
                      {{ symbol[skuItem.symbol].left }}
                    </template>
                    {{ item.num }}{{ item.unit || '份' }}
                    <template v-if="skuItem.symbolDisplayStatus">
                      {{ symbol[skuItem.symbol].right }}
                    </template>
                  </div>
                  <div class="price">￥{{ item.price }}</div>
                </div>
              </div>
            </template>
          </template>
        </div>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>
<script>
import FlodText from '@/component/common/foldText.vue'
export default {
  components: { FlodText },
  props: {
    data: Array
  },
  data() {
    return {
      containerWidth: 0,
      swiperHeight: {},
      current: 0,
      symbol: {
        0: {
          left: '(',
          right: ')'
        },
        1: {
          left: '[',
          right: ']'
        },
        2: {
          left: '【',
          right: '】'
        },
        3: {
          left: '{',
          right: '}'
        },
        4: {
          left: '"',
          right: '"'
        }
      }
    }
  },
  mounted() {
    this.containerWidth = this.$refs.setMeal.clientWidth
    this.getSkuSwiperItemHeight()
  },
  methods: {
    onSwiperChange(e) {
      this.current = e
    },
    getSkuSwiperItemHeight() {
      this.data.map((item, index) => {
        let el = this.$refs.setMeal.getElementsByClassName(`sku-item-${index}`)[0]
        this.swiperHeight[index] = el.clientHeight
      })
    },
    swipeTo(index) {
      this.$refs.swiper.swipeTo(index)
      this.current = index
    }
  }
}
</script>
<style lang="less" scoped>
.set-meal {
  margin-bottom: 15px;
  background: #fff;
  .title {
    font-size: 16px;
    font-weight: bold;
    color: #343434;
    margin-bottom: 10px;
    word-break: break-all;
    white-space: normal;
    padding: 15px;
    padding-bottom: 0;
  }
  .sku-list {
    overflow: auto;
    padding: 0 15px;

    .sku-name {
      display: inline-block;
      margin-bottom: 10px;
      font-size: 14px;
      word-break: break-all;
      white-space: normal;
      background-color: #f5f5f5;
      border: 1px solid #f5f5f5;
      border-radius: 30px;
      padding: 5px 15px;
      color: #333333;
      margin-right: 10px;
      transition: all 0.3s;
      &:active {
        filter: brightness(90%);
      }

      &.active {
        border-color: #f92125;
        color: #f92125;
        background-color: #ffebeb;
      }
    }
  }
  .container {
    white-space: nowrap;
    height: 300px;
    transition: all 0.3s;

    .van-swipe-item {
      overflow: visible;
      box-sizing: border-box;
      border-radius: 10px;
      transition: all 0.3s;
      padding-right: 15px;

      .sku-item {
        background-color: #fff;
        padding: 15px;
        overflow: hidden;
        border-radius: 10px;

        .setmeal-item {
          margin-bottom: 15px;

          &:last-child {
            margin-bottom: 0;
          }

          .setmeal-name {
            font-size: 14px;
            color: #000;
            position: relative;
            font-weight: bold;
            padding: 10rpx 0;
            padding-left: 10px;
            word-break: break-all;
            white-space: normal;

            &::before {
              content: '';
              position: absolute;
              left: 0;
              top: 50%;
              transform: translateY(-50%);
              width: 3px;
              height: 3px;
              background-color: #000;
              border-radius: 50%;
            }
          }

          .item {
            display: flex;
            align-items: center;
            padding: 5px 0;
            padding-left: 10px;

            .name {
              flex: 1;
              overflow: hidden;
              word-break: break-all;
              white-space: normal;
              font-size: 14px;
              color: #333;
            }

            .num {
              font-size: 12px;
              color: #999;
              margin-right: 15px;
              margin-left: 7px;
            }

            .price {
              font-size: 14px;
              color: #444;
              font-weight: bold;
            }
          }
        }
      }
    }
  }
}
</style>
